const prefix = '@retailMedia/accountInfo'

export const GET_ACCOUNT_INFO = `${prefix}/GET_ACCOUNT_INFO`

export const types = {
  get: GET_ACCOUNT_INFO
}
